"use client";
import React, { useState, useEffect } from "react";
import { Plus, Pencil, Trash2, X } from "lucide-react";
import { useBlogs } from "../context/BlogContext";

export default function BlogAdmin() {

const { getBlogs, createBlog, updateBlog, deleteBlog } = useBlogs();

const [blogs,setBlogs] = useState([]);
const [open,setOpen] = useState(false);
const [editing,setEditing] = useState(null);

const [form,setForm] = useState({
image:null,
title:"",
author:"",
description:"",
content:"",
tags:""
});

/* ======================
FETCH BLOGS
====================== */

const fetchBlogs = async () => {
const res = await getBlogs();
if(res?.data){
setBlogs(res.data);
}
};

useEffect(()=>{
fetchBlogs();
},[]);


/* ======================
IMAGE
====================== */

const handleImage = (e) => {
const file = e.target.files[0];
if(file){
setForm({...form,image:file});
}
};


/* ======================
SUBMIT
====================== */

const handleSubmit = async () => {

const formData = new FormData();

formData.append("title",form.title);
formData.append("author",form.author);
formData.append("description",form.description);
formData.append("content",form.content);
formData.append("tags",JSON.stringify(form.tags.split(",")));
formData.append("create_audit_id",localStorage.getItem("admin_id"));

if(form.image){
formData.append("image",form.image);
}

if(editing){

await updateBlog(editing,formData);

}else{

await createBlog(formData);

}

fetchBlogs();

setForm({
image:null,
title:"",
author:"",
description:"",
content:"",
tags:""
});

setEditing(null);
setOpen(false);

};


/* ======================
EDIT
====================== */

const handleEdit = (blog)=>{

setEditing(blog.id);

setForm({
image:null,
title:blog.title,
author:blog.author,
description:blog.description,
content:blog.content,
tags: JSON.parse(blog.tags).join(",")
});

setOpen(true);

};


/* ======================
DELETE
====================== */

const handleDelete = async (id)=>{
await deleteBlog(id);
fetchBlogs();
};


/* ======================
UI
====================== */

return (

<div className="p-6 bg-gray-50 min-h-screen">

{/* Actions bar */}
<div className="flex justify-end mb-4">
<button onClick={()=>setOpen(true)}
  className="flex items-center gap-2 bg-teal-600 hover:bg-teal-700 text-white px-4 py-2 rounded-xl font-semibold text-sm transition-colors shadow-sm">
  <Plus size={16}/><span className="hidden sm:inline">Add Blog</span>
</button>
</div>

{/* TABLE */}
<div className="bg-white rounded-xl shadow overflow-x-auto">
<table className="w-full text-sm">
<thead className="bg-teal-700 text-white">

<tr>

<th className="p-4">ID</th>
<th className="p-4">Image</th>
<th className="p-4">Title</th>
<th className="p-4">Author</th>
<th className="p-4">Description</th>
<th className="p-4">Tags</th>
<th className="p-4">Actions</th>

</tr>

</thead>

<tbody>

{blogs?.map(blog => (

<tr key={blog.id} className="border-t">

<td className="p-4">{blog.id}</td>

<td className="p-4">

{blog.image && (
<img
src={`https://acsdev.in/manaprint_backend/public/uploads/blogs/${blog.image}`}
className="w-14 h-14 object-cover rounded"
/>
)}

</td>

<td className="p-4 font-medium">{blog.title}</td>

<td className="p-4">{blog.author}</td>

<td className="p-4 max-w-xs truncate">{blog.description}</td>

<td className="p-4">

<div className="flex flex-wrap gap-2">

{JSON.parse(blog.tags || "[]").map((tag,i)=>(

<span
key={i}
className="text-xs bg-indigo-100 text-indigo-700 px-2 py-1 rounded"
>

#{tag}

</span>

))}

</div>

</td>

<td className="p-4 flex gap-3">

<button onClick={()=>handleEdit(blog)} className="text-blue-600">
<Pencil size={18}/>
</button>

<button onClick={()=>handleDelete(blog.id)} className="text-red-600">
<Trash2 size={18}/>
</button>

</td>

</tr>

))}

</tbody>

</table>

</div>


{/* MODAL */}

{open && (

<div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">

<div className="bg-white w-full max-w-xl rounded-xl p-6 relative">

<button
onClick={()=>setOpen(false)}
className="absolute right-4 top-4"
>
<X/>
</button>

<h2 className="text-xl font-semibold mb-4">
{editing ? "Edit Blog" : "Add Blog"}
</h2>


<div className="space-y-4">

<input type="file" onChange={handleImage} className="w-full"/>

<input
type="text"
placeholder="Title"
className="w-full border p-2 rounded"
value={form.title}
onChange={(e)=>setForm({...form,title:e.target.value})}
/>

<input
type="text"
placeholder="Author"
className="w-full border p-2 rounded"
value={form.author}
onChange={(e)=>setForm({...form,author:e.target.value})}
/>

<textarea
placeholder="Short Description"
rows="3"
className="w-full border p-2 rounded"
value={form.description}
onChange={(e)=>setForm({...form,description:e.target.value})}
/>

<textarea
placeholder="Full Blog Content"
rows="6"
className="w-full border p-2 rounded"
value={form.content}
onChange={(e)=>setForm({...form,content:e.target.value})}
/>

<input
type="text"
placeholder="Tags (comma separated)"
className="w-full border p-2 rounded"
value={form.tags}
onChange={(e)=>setForm({...form,tags:e.target.value})}
/>

<button
onClick={handleSubmit}
className="w-full bg-indigo-600 text-white py-2 rounded"
>

Save Blog

</button>

</div>

</div>

</div>

)}

</div>

);

}